import { render, staticRenderFns } from "./MenuSectionLink.vue?vue&type=template&id=ae7dbafc&"
import script from "./MenuSectionLink.vue?vue&type=script&lang=js&"
export * from "./MenuSectionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuSectionLink.vue"
export default component.exports